// ** Icons Import
import { Home, Circle } from 'react-feather'

import { GrCluster  } from "react-icons/gr"

export default [
  {
    id: 'processmaps',
    title: 'Process Maps',
    icon: <GrCluster  size={20} strokeWidth={1} />,
    badge: 'light-warning',
    children: [
      {
        id: 'erdprocessmap',
        title: 'ERP Process Map',
        icon: <Circle size={12}/>,
        navLink: '/apps/processmap/ERP'
      } 
    ]
  }
]
